<template>
  <div
    v-scroll="onScroll"
    class="home"
    :style="newPostsSackbar && {
      marginTop: '64px'
    }"
  >
    <v-snackbar
      v-model="newPostsSackbar"
      color="success"
      top
      :timeout="1000000"
      class="new-post-snackbar"
    >
      <div class="d-flex align-center">
        <div class="mr-auto">
          新しい投稿があります。 ({{ newPosts.length }})
        </div>
        <v-btn
          small
          outlined
          color="white"
          @click="addNewPosts"
        >
          <span v-if="isPageTop">表示</span>
          <v-icon
            v-else
            small
          >
            fa-arrow-up
          </v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <PostCard
      v-if="isCreateListener && !posts.length"
      no-post
    />
    <PostCard
      v-for="post in posts"
      :key="post.postId"
      :post="post"
    />
    <div
      v-if="!noMorePosts"
      class="load-more"
    >
      <div
        v-if="isCreateListener && !isLoadingPosts"
        v-intersect="loadMorePosts"
      />
      <PostCard
        v-for="i in (!posts.length ? 3 : 1)"
        :key="i"
        loader
      />
    </div>
  </div>
</template>

<style lang="scss">
.home {
  > * {
    margin: auto;
  }
  .new-post-snackbar {
    top: 72px;

    .d-flex {
      width: 100%;
    }
  }
  .load-more {
    max-width: 900px;
  }
}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  data: () => ({
    postsListenerUnsubscribe: null,
    isPageTop: true,
    posts: [],
    newPosts: [],
    isCreateListener: false,
    noMorePosts: false,
    isLoadingPosts: false,
    newPostsSackbar: false
  }),
  computed: {
    isNewPosts() {
      return this.newPosts.length;
    }
  },
  mounted() {
    this.postsListenerUnsubscribe = firebase.firestore().collectionGroup('posts').orderBy('createdAt', 'desc').limit(50).onSnapshot(snapshot => {
      snapshot.docChanges().forEach(change => {
        if (change.type !== 'added') {
          return;
        }
        if (this.isCreateListener) {
          this.newPosts.unshift({
            postId: change.doc.id,
            ...change.doc.data(),
            showExplanation: false
          });
          this.newPostsSackbar = true;
          return;
        }
        this.posts.push({
          postId: change.doc.id,
          ...change.doc.data(),
          showExplanation: false
        });
      });
      if (!this.isCreateListener) {
        this.isCreateListener = true;
      }
    });
  },
  destroyed() {
    this.postsListenerUnsubscribe();
  },
  methods: {
    onScroll(e) {
      const scrollTop = e.target.scrollingElement.scrollTop;
      if (scrollTop <= 100) {
        this.isPageTop = true;
      } else {
        this.isPageTop = false;
      }
    },
    addNewPosts() {
      if (!this.isPageTop) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }
      const newPostsHeight = (103 + 12)*(this.newPosts.length - 1);
      this.posts.unshift(...this.newPosts);
      this.newPosts = [];
      this.newPostsSackbar = false;
      this.$nextTick(() => {
        window.scrollTo(0, newPostsHeight);
      });
    },
    async loadMorePosts() {
      this.isLoadingPosts = true;
      let postsRef = firebase.firestore().collectionGroup('posts').orderBy('createdAt', 'desc');
      if (this.posts.length) {
        postsRef = postsRef.startAfter(this.posts.slice(-1)[0].createdAt);
      }
      await postsRef.limit(50).get()
        .then(snapshot => {
          if (snapshot.empty) {
            throw new Error();
          }
          snapshot.forEach(doc => {
            this.posts.push({
              postId: doc.id,
              ...doc.data(),
              showExplanation: false
            });
          });
        })
        .catch(err => {
          console.error(err);
          this.noMorePosts = true;
        })
        .finally(() => {
          this.isLoadingPosts = false;
        });
    }
  }
};
</script>
